import { toExclusiveDayUpperBound } from '@/creditflowresearch/application/helpers/zonedDayBounds';

/**
 * Filter state holds the inclusive end-of-day so the picker shows the day the user picked; the
 * trace RPCs need the exclusive next-day bound because they truncate the parameter to a date and
 * compare with `<`. Apply this when building a payload, not when sending it.
 */
const widenDateToForRpc = <T extends { dateTo: number | null }>(filter: T): T => ({
  ...filter,
  dateTo: toExclusiveDayUpperBound(filter.dateTo),
});

export default widenDateToForRpc;
